import React from 'react';

const CosmicBackground = ({ children, showAstroChart = false }) => {
  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-gradient-to-b from-[#0a1628] via-[#0d1b33] to-[#101e3a]">
      {/* Removed Grid Overlay - was causing visible pattern */}

      {/* Animated Particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-blue-200 rounded-full animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 3}s`,
              opacity: Math.random() * 0.4 + 0.2
            }}
          />
        ))}
      </div>

      {/* Gradient Orbs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1.5s'}} />

      {/* Astrological Chart (Optional) */}
      {showAstroChart && (
        <div className="absolute top-20 left-1/2 transform -translate-x-1/2 w-64 h-64 md:w-80 md:h-80">
          <svg viewBox="0 0 200 200" className="w-full h-full opacity-30">
            {/* Outer Circle */}
            <circle cx="100" cy="100" r="90" fill="none" stroke="rgba(147, 197, 253, 0.3)" strokeWidth="1" />
            <circle cx="100" cy="100" r="70" fill="none" stroke="rgba(147, 197, 253, 0.2)" strokeWidth="1" />
            <circle cx="100" cy="100" r="50" fill="none" stroke="rgba(147, 197, 253, 0.2)" strokeWidth="1" />
            
            {/* Zodiac Divisions */}
            {[...Array(12)].map((_, i) => {
              const angle = (i * 30 - 90) * (Math.PI / 180);
              const x1 = 100 + 50 * Math.cos(angle);
              const y1 = 100 + 50 * Math.sin(angle);
              const x2 = 100 + 90 * Math.cos(angle);
              const y2 = 100 + 90 * Math.sin(angle);
              return (
                <line
                  key={i}
                  x1={x1}
                  y1={y1}
                  x2={x2}
                  y2={y2}
                  stroke="rgba(147, 197, 253, 0.2)"
                  strokeWidth="1"
                />
              );
            })}

            {/* Zodiac Symbols (Simplified) */}
            <text x="100" y="20" textAnchor="middle" fill="rgba(147, 197, 253, 0.4)" fontSize="14">♈</text>
            <text x="155" y="50" textAnchor="middle" fill="rgba(147, 197, 253, 0.4)" fontSize="14">♉</text>
            <text x="170" y="105" textAnchor="middle" fill="rgba(147, 197, 253, 0.4)" fontSize="14">♊</text>
            <text x="155" y="160" textAnchor="middle" fill="rgba(147, 197, 253, 0.4)" fontSize="14">♋</text>
            <text x="100" y="185" textAnchor="middle" fill="rgba(147, 197, 253, 0.4)" fontSize="14">♌</text>
            <text x="45" y="160" textAnchor="middle" fill="rgba(147, 197, 253, 0.4)" fontSize="14">♍</text>
            <text x="30" y="105" textAnchor="middle" fill="rgba(147, 197, 253, 0.4)" fontSize="14">♎</text>
            <text x="45" y="50" textAnchor="middle" fill="rgba(147, 197, 253, 0.4)" fontSize="14">♏</text>
          </svg>
        </div>
      )}

      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default CosmicBackground;